export const categories = [
  {
    slug: "stepmother-relationship",
    name: "继母相处之道",
    description: "探索继母与孩子建立信任与亲密关系的实用方法，从日常沟通到情感连接，一步一步构建健康的继母角色。",
    icon: "ri-heart-line",
  },
  {
    slug: "stepsister-relationship",
    name: "继姐关系处理",
    description: "面对继姐的相处难题？这里有从冲突化解到姐妹情谊培养的完整指南。",
    icon: "ri-user-heart-line",
  },
  {
    slug: "blended-family-psychology",
    name: "重组家庭心理",
    description: "深入理解重组家庭中的心理动态，学会识别和应对各类情绪挑战。",
    icon: "ri-mental-health-line",
  },
  {
    slug: "family-repair",
    name: "家庭关系修复",
    description: "当家庭关系出现裂痕时，这里有科学的修复策略和温暖的治愈故事。",
    icon: "ri-heart-pulse-line",
  },
];